
import { mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            userinfo: 'user/userinfo',
            userAccount: 'user/userAccount'
        })
    },
    data() {
        return {
            tabClickIndex: 0, // 0 我的咨询 1 咨询我的
            tabClickData: [
                { title: '我咨询的', img: 'https://oss.pzds.com/pc-ssr-im/recentConsultation_icon_no_1.png', active: 'https://oss.pzds.com/pc-ssr-im/recentConsultation_icon_1.png', number: 0 },
                { title: '咨询我的', img: 'https://oss.pzds.com/pc-ssr-im/recentConsultation_icon_2.png', active: 'https://oss.pzds.com/pc-ssr-im/recentConsultation_icon_ac_2.png', number: 0 }
            ],
            pageInfo: {
                page: 1,
                pageSize: 10,
                total: 0
            },
            listData: [],
            loading: true
        }
    },
    mounted() {
        // 获取统计数据
        this.$store.dispatch('user/UserCenterStatistics')
        this.tabClickData[0].number = this.userAccount?.consultBuyerCount
        this.tabClickData[1].number = this.userAccount?.consultSellerCount
        this.tabClickIndex = this.$route.query.tabClickIndex || 0
        this.getList()
    },
    methods: {
        // tab切换
        tabClick(item, index) {
            if (this.tabClickIndex == index) return
            this.tabClickIndex = index
            this.pageInfo.page = 1
            this.pageInfo.pageSize = 10
            this.pageInfo.total = 0
            this.getList()
            this.$store.dispatch('user/UserCenterStatistics')
            this.$router.push({
                path: '/recentConsultation',
                query: { tabClickIndex: this.tabClickIndex }
            })
        },
        // 查看回复
        gotoDtl(item) {
            this.$router.push({ path: '/recentConsultationDtl', query: { goodsNo: item.goodsNo, value: item.value } })
        },
        // 回复提交
        gotoSubmit(item) {
            this.$router.push({ path: '/recentConsultationSubmit', query: { goodsNo: item.goodsNo } })
        },
        // 下一页
        handleCurrentChange(page) {
            this.pageInfo.page = page
            let _page = {
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize
            }
            this.getList()
        },
        // 分页总数
        handleSizeChange(pageSize) {
            this.pageInfo.page = 1
            this.pageInfo.pageSize = pageSize
            let _page = {
                page: 1,
                pageSize: this.pageInfo.pageSize
            }
            this.getList()
        },
        // 获取列表
        getList() {
            let p = {
                action: {},
                page: this.pageInfo.page,
                pageSize: this.pageInfo.pageSize
            }
            this.loading = true
            let _api = this.tabClickIndex == 0 ? this.$api.getConsultLabelBuyerList : this.$api.getConsultLabelSellerList
            _api(p).then((res) => {
                if (!res.success) {
                    this.$message.error(res.info)
                    this.loading = false
                    return
                }
                let data = res.data
                this.listData = data.records
                this.pageInfo.page = data.page
                this.pageInfo.total = data.total
                this.loading = false
            })
        }
    }
}
